module.exports = __webpack_public_path__ + "img/bb.5c78aba4.svg";